document.addEventListener('DOMContentLoaded', function () {
  processCartImages('.cart-item')
  watchDrawer()
  watchCartItems()
  listenForCartUpdates()
})

function processCartImages(selector) {
  const rows = document.querySelectorAll(selector)
  rows.forEach((row) => {
    const image = row.querySelector('img')
    if (!image) return

    const dtNodes = row.querySelectorAll('.cart-item__property')
    dtNodes.forEach((node) => {
      const text = node.textContent
      if (text.includes('pacdora-image3D:')) {
        const ddNode = node.querySelector('span')
        if (ddNode) {
          image.src = ddNode.textContent
          image.srcset = `${ddNode.textContent}?crop=center&height=144&width=120 100w, 
          ${ddNode.textContent}?crop=center&height=264&width=220 200w, 
          ${ddNode.textContent}?crop=center&height=384&width=320 300w`
        }
        node.style.display = 'none'
      }
    })
  })
}

/**
dynamic watch drawer, if drawer is visible, do switchimage
**/
// 使用MutationObserver监听drawer的可见性变化

function watchDrawer() {
  // .cart-notification for cart drawer
  // .cart-items for cart item in cart page
  const cartNotification = document.querySelector('#site-cart-sidebar')
  if (!cartNotification) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
        // 获取当前的可见性状态
        const isVisible = window.getComputedStyle(cartNotification).visibility === 'visible'

        if (isVisible) {
          processCartImages('.cart-item')
        }
      }
    })
  })

  const config = { attributes: true, attributeFilter: ['style', 'class'] }
  observer.observe(cartNotification, config)
}

function watchCartItems() {
  const form = document.querySelector('form#cart')
  if (!form) return

  // Process existing items first
  processCartImages('.cart-form-item')
  
  // Set up observer for dynamic changes
  const observer = new MutationObserver(() => {
    processCartImages('.cart-form-item')
  })

  const config = { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  }
  observer.observe(form, config)
}

function listenForCartUpdates() {
  const cartForm = document.getElementById('AjaxCartForm')
  if (cartForm) {
    cartForm.addEventListener('cart-updated', function() {
      processCartImages('.cart-form-item')
    })
  }
}
